/**
****************************************************************************************
Project: Readabl
File: CircularProgressWithLabel.js
Description: This file design for percentage loader. It will display number percentage pdf loaded.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const CircularProgressWithLabel = (props) => {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex', height: "inherit" }}>
        <CircularProgress variant="determinate" {...props} />
        <Typography 
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
        }} variant="caption" component="div">
            {`${Math.round(props.value)}%`}
          </Typography>
      </Box>
    );
}

export default CircularProgressWithLabel;